import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import _ from 'lodash';

import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';
import webClient from '../../core/web_client';
import { buildQueryParamValueArray, buildQueryString, extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { CUSTOMER_RESERVATIONS_PATH } from '../../core/constants';

export const getCustomerReservationsAction = createAsyncThunk(
    'reservation/getCustomerReservationsAction',
    async (queryParams, { fulfillWithValue, rejectWithValue }) => {
        try {
            const reservationStatuses = buildQueryParamValueArray(_.pick(queryParams, ['reservationStatuses']).reservationStatuses);
            const response = await webClient.get(`${ CUSTOMER_RESERVATIONS_PATH }/${ queryParams.customerId }/reservations${ buildQueryString(_.omit(queryParams, ['reservationStatuses', 'customerId'])) }&reservationStatus=${ reservationStatuses }`);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const getCustomerReservationsSlice = createSlice({
    name: 'getCustomerReservationsSlice',
    initialState: DEFAULT_STATE,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(getCustomerReservationsAction.pending, () => STATE__API__STARTED);
        builder.addCase(getCustomerReservationsAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(getCustomerReservationsAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const getCustomerReservationsState = (state) => state.reservation.getCustomerReservations;
export default getCustomerReservationsSlice.reducer;
